import { SiePedidosBaseAPI } from "@/api/sie-pedidos.base.api";
import {
  VUE_APP_SIE_PEDIDOS_API_URL
} from "@/commons/config";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { DadosAluno } from "@/models/sie-pedidos/dadosAluno";
import { Pagination } from "@/models/sit-pedido/pagination";
import { Lote } from "@/models/sie-pedidos/lote";
import { DadosFilterSolicitacao, PaginationTableSiePedidos } from "@/store/modules/sie-pedidos/states/table";
import { PaginationTableLotes } from "@/store/modules/sie-pedidos/states/tableLotes";
import { Solicitacao } from "@/models/sie-pedidos/solicitacao";
import dayjs from "dayjs";

export class EntidadeApi extends SiePedidosBaseAPI<DadosAluno> {
  constructor() {
    super();
    this.apiUrl = VUE_APP_SIE_PEDIDOS_API_URL;
  }

  public getDadosFilterSolicitacao(): AxiosObservable<DadosFilterSolicitacao> {
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/setup-list`);
  }

  public getLista(input: PaginationTableSiePedidos): AxiosObservable<Pagination<Solicitacao>> {
    const url = `${this.apiUrl}/central-servicos/entidades/solicitacoes`;

    const normalizeCpf = (cpf?: string | null): string | undefined =>
      cpf ? cpf.replace(/[^0-9a-zA-Z]/g, "") : undefined;

    const normalizeDate = (value?: string | null): string | undefined => {
      if (!value) return undefined;
      const d = dayjs(value);
      return d.isValid() ? d.format("YYYY-MM-DD") : undefined;
    };

    const dataInicio = normalizeDate(input.dataInicio);
    const dataFim = normalizeDate(input.dataFim) ?? dataInicio;

    const params: Record<string, any> = { ...input };
    params.cpf = normalizeCpf(input.cpf);

    if (dataInicio) {
      params.dataInicio = dataInicio;
    } else {
      delete params.dataInicio;
    }

    if (dataFim) {
      params.dataFim = dataFim;
    } else {
      delete params.dataFim;
    }

    return this.axios.get(url, { params });
  }

  public getDetalhamentoSolicitacao(id: any) {
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/detail/${id}`);
  }

  public getListHistoricoSolicitacao(idSolicitacao: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/solicitacao-historico`, { params: { idSolicitacao } });
  }

  public receberSolicitacaoSindionibus(id: number): AxiosObservable<any> {
    return this.axios.put(`${this.apiUrl}/central-servicos/lotes/entidade-recebe-lote/${id}`);
  }

  public enviarCarteiraAluno(ids: number[]): AxiosObservable<any> {
    return this.axios.put(`${this.apiUrl}/central-servicos/entidades/solicitacoes/solicitacao-entregue-aluno`, { ids });
  }

  public getListaLotesPorEntidade(filter: PaginationTableLotes): AxiosObservable<Pagination<Lote>> {
    const url = `${this.apiUrl}/central-servicos/lotes/consulta-lote-entidade`;

    const normalizeDate = (value?: string | null): string | undefined => {
      if (!value) return undefined;
      const d = dayjs(value);
      return d.isValid() ? d.format("YYYY-MM-DD") : undefined;
    };

    const dataInicio = normalizeDate(filter.dataInicio);
    const dataFim = normalizeDate(filter.dataFim) ?? dataInicio;

    const params: Record<string, any> = { ...filter };

    if (dataInicio) {
      params.dataInicio = dataInicio;
    } else {
      delete params.dataInicio;
    }

    if (dataFim) {
      params.dataFim = dataFim;
    } else {
      delete params.dataFim;
    }

    return this.axios.get(url, { params });
  }

  public getListaStatusLotes(): AxiosObservable<[]> {
    return this.axios.get(`${this.apiUrl}/central-servicos/lotes/setup-list`);
  }

  public getListHistoricoLote(idLote: any): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/central-servicos/lotes/lote-historico`, { params: { idLote } });
  }
}
